// extracted by mini-css-extract-plugin
module.exports = {"centeredForm":"CenteredForm_centeredForm__qIxj6","navMenu":"CenteredForm_navMenu__3JDId"};